import { ApolloProvider } from '@apollo/client';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';

import { MainWrapper, themeFlix, themeFlixDark, ThemeWrapper } from '@flixbus/honeycomb-react';

import { authStore } from 'auth/authStore';
import AppUpdatePrompt from 'common/AppUpdate';
import { client } from 'contexts/ApolloClient/apolloClient';
import AppRouter from 'contexts/Router';
import { ThemeContext, useFlixThemeState } from 'contexts/ThemeContext';
import RootNotificationContainer from 'global/RootNotificationContainer';

import styles from './styles.module.css';

const AppContext = observer(() => {
	const { theme, toggleTheme, isDark } = useFlixThemeState();

	useEffect(() => {
		authStore.initializeAuth();
	}, []);

	return (
		<ThemeContext.Provider value={{ theme, toggleTheme, isDark }}>
			<ApolloProvider client={client}>
				<ThemeWrapper
					applyToRoot
					theme={theme}
					themes={{ flix: themeFlix, 'flix-dark': themeFlixDark }}
				>
					<MainWrapper extraClasses={styles.padding} full>
						<AppUpdatePrompt />
						<AppRouter />
						<RootNotificationContainer />
					</MainWrapper>
				</ThemeWrapper>
			</ApolloProvider>
		</ThemeContext.Provider>
	);
});

export default AppContext;
